<template lang="pug">
  v-app(id="app")
    v-navigation-drawer(id="drawer" app v-model="drawer" hide-overlay=true)
      SearchPlaces(:zoomLevel="zoomLevel")
      FriendsLocConfig()
    v-container(app fluid pa-0 ma-0 fill-height)
      v-layout(column)
        MapView(@menuClicked="drawer = !drawer" 
                @rainviewerOverlayAdded="showRainSlider = true"
                @rainviewerOverlayRemoved="showRainSlider = false"
                @newRainviewerOverlays="onNewOverlays"
                :rainviewerLayerToDisplay="rainviewerSliderValue"
                @weatherOverlayAdded="showWeatherSlider = true"
                @weatherOverlayRemoved="showWeatherSlider = false"
                @newWeatherTimestamps="onNewWeatherTimestamps"
                :weatherLayerToDisplay="weatherSliderValue"
                @zoomChanged="onZoomChanged")
        v-flex(v-if="showRainSlider" mt-2 mb-4 style="witdh:100%")
          SliderWidget(:name="'rainviewerSlider'"
                      :sliderMaxi="rainviewerSliderMax"
                      :initial_value="rainviewerSliderValue"
                      :labels="rainviewer_labels"
                      @valueChanged="onRainviewerSliderValueChanged")
        v-flex(v-if="showWeatherSlider" mt-2 mb-4 style="witdh:100%")
          SliderWidget(:name="'weatherSlider'"
                      :sliderMaxi="weather_slider_max"
                      :initial_value="0"
                      :labels="weather_slider_labels"
                      @valueChanged="onWeatherSliderValueChanged")
    NotificationWidget
</template>

<script>
import SearchPlaces from "./components/SearchPlaces.vue"
import MapView from "./components/MapView.vue"
import NotificationWidget from "./components/NotificationWidget.vue"
import SliderWidget from "./components/SliderWidget.vue"
import FriendsLocConfig from "./components/FriendsLocConfig.vue"
import { app_mgr, app_state } from "./js/app_state"
import { APIRoute, RouteType } from './js/api_route'

export default {
  name: 'app',
  
  components: {
    MapView,
    SearchPlaces,
    SliderWidget,
    NotificationWidget,
    FriendsLocConfig
  },
  
  data () {
    return {
      drawer: false,
      showRainSlider:false,
      rainviewerSliderMax: 0,
      rainviewerSliderValue: app_state.current_rainviewer_timestamp,
      rainviewer_labels: [],
      showWeatherSlider: false,
      weather_slider_max: 0,
      weatherSliderValue: 0,
      weather_slider_labels: [],
      zoomLevel: 0,
    }
  },

  mounted() {
    // add a callback to window.onbeforeunload to call user defined onbeforeunload callbacks on children components recursively
    // => create a mixin component ?
    window.onbeforeunload = function() {
      function doCallBeforeUnload(child) {
        try {
          child.onBeforeUnload();
        } catch { /* do nuthin */
        }
          finally {
          for (let _child of child.$children) {
            if (!_child._isVue) continue;
            doCallBeforeUnload(_child);
          }
        }
      }
      for (let cchild of this.$children) {
          doCallBeforeUnload(cchild);
      }
    }.bind(this);
    app_mgr.addWaypoint();
    this.parseURL();
  },

  methods: {
    onNewOverlays (availableOverlaysLength, labels) {
      this.rainviewerSliderMax = availableOverlaysLength - 1;
      this.rainviewer_labels = labels;
    },

    onRainviewerSliderValueChanged (value) {
      this.rainviewerSliderValue = value;
      app_state.current_rainviewer_timestamp = value;
    },

    onNewWeatherTimestamps (timestamps) {
      this.weather_slider_max = timestamps.length - 1;
      this.weather_slider_labels = timestamps;
      this.showWeatherSlider = false;
      this.showWeatherSlider = true;
    },

    onWeatherSliderValueChanged (value) {
      this.weatherSliderValue = value;
    },

    onZoomChanged (value) {
      this.zoomLevel = value;
    },

    parseURL() {
      let pf = parseFloat;
      const params = this.$route.params;
      if (Object.keys(params).length === 0) {
        return;
      }
      if (params.from === undefined) return;
      const from_str = params.from.split(",");
      const from = [pf(from_str[0]), pf(from_str[1])];
      const to_str = params.to.split(",");
      if (params.to === undefined) return;
      const to = [pf(to_str[0]), pf(to_str[1])];
      let by = [];
      if (params.by != undefined) {
        const by_str = params.by.split(",");
        for (let i = 0; i < by_str.length; i+=2) {
          by.push([pf(by_str[i]), pf(by_str[i+1])]);
        }
      }
      let wp_id = 0;
      app_mgr.setWaypointValues(wp_id, from[0], from[1]);
      for (let wp of by) {
        wp_id = app_mgr.addWaypoint();
        app_mgr.setWaypointValues(wp_id, wp[0], wp[1]);
      }
      wp_id = app_mgr.addWaypoint();
      app_mgr.setWaypointValues(wp_id, to[0], to[1]);
      
      let wp_coord = [];
      for (let wp of app_state.waypoints) {
        wp_coord.push([wp.lon, wp.lat]);
      }
      APIRoute.getRoute(wp_coord, RouteType.REGULAR)
      .then(data => {
        app_mgr.setCurrentPath(data.distance, data.duration, data.features, data.features_collection, data.ascent, data.descent);
          
      })
    },
  }
}
</script>

<style>
html {
-webkit-user-select: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#drawer {
  opacity: 0.9;
}
</style>

